export default __webpack_public_path__ + "static/media/foreign-card-bg.a408771a.svg";